import ActivateRemoteLoginCodePage from './ActivateRemoteLoginCodePage'

export default ActivateRemoteLoginCodePage
// eslint-disable-next-line import/export
export * from './ActivateRemoteLoginCodePage'
